// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"we_a bhk_b","TwoDimsListFeature__item":"we_b bhk_wb","TwoDimsListFeature__item__text":"we_c bhk_vr"};